
import localforage from "localforage";
class LocalStore {
    constructor() {
        this.$store = localforage
        this.percentageUsed = null
        this.remaining = null
        this.maxIndexBDstorageFn()
    }
    _localforageSet(key, value) {
        if(this.remaining <= 100) {
            console.error('You have run out of remaining memory');
            return 
        }
        return this.$store.setItem(key, value)
    }
    _localforageGet(key) {
        this.$store.getItem(key)
        return this.$store.getItem(key)
    }
    _localforageGetRemove(key) {
        return this.$store.removeItem(key)
    }
    _localforageClearAll() {
        this.$store.clear()
    }
    unitFn(by) {
        return (by/(1024 * 1024)).toFixed(2)
    }
    async maxIndexBDstorageFn() {
        if (navigator.storage && navigator.storage.estimate) {
            const quota = await navigator.storage.estimate();
            this.percentageUsed = (quota.usage / quota.quota) * 100;
            this.remaining = quota.quota - quota.usage;
            console.log(`you use ${this.unitFn(this.percentageUsed) + "MB"}%。`);
            console.log(`you max input ${this.unitFn(this.remaining) + "MB"} by。`);
        }
    }
}
export const localStoreServer = new LocalStore()
